module.exports = __webpack_public_path__ + "img/Nuns.51bd35e9.webp";